import { $api } from "@babackapp/private-api-client/generated/client";
import { useQueryClient } from "@tanstack/react-query";

const PATH =
  "/internal/pii-vault/shops/{shopId}/return-requests/{returnRequestId}/customer";

const queryKey = (shopId: string, returnRequestId: string) => [
  "get",
  PATH,
  { params: { path: { shopId, returnRequestId } } },
];

/**
 * Reads a return request's customer through the PII vault instead of the
 * plaintext document. Super-admin only, so callers pass `enabled` rather than
 * letting every viewer hit a route they cannot use.
 */
export function useReturnRequestVaultCustomer(
  shopId: string,
  returnRequestId: string,
  enabled: boolean,
) {
  return $api.useQuery(
    "get",
    PATH,
    { params: { path: { shopId, returnRequestId } } },
    { enabled },
  );
}

/** The dual write lands before the edit responds, so refetching is enough. */
export function useInvalidateReturnRequestVaultCustomer() {
  const queryClient = useQueryClient();

  return (shopId: string, returnRequestId: string) =>
    queryClient.invalidateQueries({
      queryKey: queryKey(shopId, returnRequestId),
    });
}
